import { Alert } from '@packages/ui/base/alert/alert';
import { Button } from '@packages/ui/base/button/button';
import { Card } from '@packages/ui/base/card/card';

export interface DrawCardProps {
  onDrawClick: () => void;
  isLoading?: boolean;
  errorMessage?: string;
}

export const DrawCard = ({ onDrawClick, isLoading = false, errorMessage }: DrawCardProps) => {
  return (
    <Card className="py-6">
      <h2 className="mb-1 text-xl font-bold">Ready to draw?</h2>

      <p className="text-muted-foreground mb-6">Click the button below to see your match.</p>

      {errorMessage && (
        <Alert variant="error" className="mb-6">
          {errorMessage}
        </Alert>
      )}

      <Button onClick={onDrawClick} className="w-full" loading={isLoading} disabled={isLoading}>
        <span>Draw your match</span>
      </Button>
    </Card>
  );
};
